import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query"
import * as Icon from 'react-bootstrap-icons';

import { startLogout } from '../../../../redux/slices/auth';

import { Notices } from "../../../../components";

import styles from './Navbar.module.css';

export const Navbar = () => {

    const location = useLocation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const carpetButton = useRef(null);

    const queryClient = useQueryClient();

    const { user } = useSelector(state => state.auth);

    // const handleAgenda = () => {
    //     if(!(location.pathname === '/agenda' || location.pathname === '/')){
    //         navigate("/agenda");
    //     }
    // }

    // const handleInmunoterapias = () => {
    //     if(!(location.pathname === '/inmunoterapias')){
    //         navigate("/inmunoterapias");
    //     }
    // }

    const handleMedicos = () => {
        if(!(location.pathname === '/medicos')){
            navigate("/medicos");
        }
    }

    const handleMovilMenuContract = () => {
        carpetButton.current?.click();
    }

    const handleLogout = () => {
        dispatch(startLogout());
        queryClient.clear();
        navigate("/");
    }

    return (
        <>
            <nav className={"navbar fixed-top bg-body-tertiary p-3 " + styles.navbar}>
                <div className={"container-fluid " + styles.navbarContainerFluid}>
                    <Link to="/" className={styles.navbarMovil}>
                        <div className={styles.navbarLogo} />
                    </Link>
                    <div className={styles.navbarMovil}>
                        <Notices />
                    </div>
                    <button className={"navbar-toggler " + styles.navbarMovil} type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation" ref={carpetButton}>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={"collapse navbar-collapse " + styles.navbarMovil} id="navbarTogglerDemo02">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="mt-3">
                                <div className={styles.navbarDropdownTop}>
                                    <div>
                                        <div className={styles.navbarDropdownHeader}>{user.displayName}</div>
                                    </div>
                                </div>
                            </li>
                            <li className={styles.navbarDropdownMenuItem}>
                                <div className={"dropdown " + styles.navbarDropdown}>
                                    <button className={"btn dropdown-toggle " + styles.navbarDropdownMovilButton} type="button" data-bs-toggle="dropdown" aria-expanded="false">Configuración</button>
                                    <ul className={"dropdown-menu " + styles.navbarDropdownSubMenu}>
                                        <li className={styles.navbarDropdownMenuSubItem} onClick={handleMovilMenuContract}><Link to="/perfil"><div className="dropdown-item" />Perfil</Link></li>
                                    </ul>
                                </div>
                            </li>
                            <li className={styles.navbarDropdownMenuItem} onClick={handleMovilMenuContract}><div className={styles.navbarLogoutMovil} onClick={handleLogout}>Logout</div></li>
                        </ul>
                    </div>
                    <div className={"row justify-content-around " + styles.navbarWeb}>
                        <div className="col">
                            <div className="d-flex">
                                <Link to="/">
                                    <div className={styles.navbarLogo} />
                                </Link>
                            </div>
                        </div>
                        <div className="col d-flex justify-content-end">
                            <Notices />
                            <div className={styles.navbarDropdownContainer}>
                                <div className={"dropdown " + styles.navbarDropdown}>
                                    <button className={"btn dropdown-toggle " + styles.navbarDropdownButton} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {user.displayName}
                                    </button>
                                    <ul className={"dropdown-menu " + styles.navbarDropdownMenu}>
                                        <li>
                                            <div className={styles.navbarDropdownTop}>
                                                <div>
                                                    <div className={styles.navbarDropdownHeader}>{user.displayName}</div>
                                                </div>
                                                <div><Icon.X className={styles.navbarDropdownClose} /></div>
                                            </div>
                                        </li>
                                        <li className={styles.navbarDropdownMenuItem}><Link to="/perfil"><div className="dropdown-item" />Configuración</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className={styles.logoutIconContainer}>
                                <Icon.BoxArrowRight className={styles.logoutIcon} onClick={handleLogout} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid d-block">
                    <div className="row">
                        <div className="col">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="container-fluid d-block">
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            {/* <div className={styles.navbarTab + ((location.pathname === '/agenda' || location.pathname === '/') ? " " + styles.navbarTabActive : "")} onClick={handleAgenda}><div className={styles.navbarTabIcon + ((location.pathname === '/agenda' || location.pathname === '/') ? " " + styles.navbarTabIcon11 : " " + styles.navbarTabIcon1)}></div> Agenda</div> */}
                            {/* <div className={styles.navbarTab + ((location.pathname === '/inmunoterapias') ? " " + styles.navbarTabActive : "")} onClick={handleInmunoterapias}><div className={styles.navbarTabIcon + ((location.pathname === '/inmunoterapias') ? " " + styles.navbarTabIcon21 : " " + styles.navbarTabIcon2)}></div> Inmunoterapias</div> */}
                            <div className={styles.navbarTab + ((['/medicos'].includes(location.pathname) || location.pathname.includes('/medico/')) ? " " + styles.navbarTabActive : "")} onClick={handleMedicos}><div className={styles.navbarTabIcon + ((['/medicos'].includes(location.pathname) || location.pathname.includes('/medico/')) ? " " + styles.navbarTabIcon31 : " " + styles.navbarTabIcon3)}></div> Médicos</div>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}
